module.exports = __webpack_public_path__ + "img/brilliant-graphics.c562cb2c.jpg";